import { defineComponent } from 'vue';
import FiscalYearTableComponent from '@/components/fiscalYearTable/FiscalYearTable.vue';

export default defineComponent({
  name: 'FiscalYearPage',
  components: {
    FiscalYearTableComponent,
  },
});
